import * as React from "react";
import type { SVGProps } from "react";
const SvgDotsThreeVertical = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill={props.color}
      d="M8.75 8a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0M4.5 8A.75.75 0 1 0 3 8a.75.75 0 0 0 1.5 0M13 8a.75.75 0 1 0-1.5 0A.75.75 0 0 0 13 8"
    />
  </svg>
);
export default SvgDotsThreeVertical;
